import { thermalMeasurementTypeTranslated } from 'components/Form/meter_details/constants';
import { MeterDetails as messages } from 'components/Form/meter_details/messages';
import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ThermalMeasurementType } from '@enmon/commons';
import { useMeterModelSuggestionsStore } from '../../../store/useMeterModelSuggestionsStore';
import { Select } from '../Select';
import { getSelectOptionsWithSuggestions } from '../utils/getSelectOptionsWithSuggestions';

interface ThermalMeasurementTypeSelectProps {
  value?: ThermalMeasurementType;
  onChange?: (value: ThermalMeasurementType) => void;
}

export const ThermalMeasurementTypeSelect: VFC<ThermalMeasurementTypeSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const thermalMeasurementTypeOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(ThermalMeasurementType),
        suggestedValue: meterModelSuggestions?.thermalMeasurementType?.value,
        suggestedSelection: meterModelSuggestions?.thermalMeasurementType?.selection,
        labelFormatter: (value: ThermalMeasurementType) => intl.formatMessage(thermalMeasurementTypeTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={thermalMeasurementTypeOptions}
      placeholder={<FormattedMessage {...messages.thermalMeasurementTypePlaceholder} />}
      {...restProps}
    />
  );
};
